import cropSequenceAddCulturePopup from './addCulturePopup.html';
import { stringify } from 'csv-stringify'
import { saveAs } from 'file-saver';

angular.module('cfn').controller('cropSequencePlanningController', [
  '$scope',
  '$rootScope',
  '$http',
  '$filter',
  '$timeout',
  '$q',
  '$location',
  '$locale',
  'cropSequencePlanningService',
  'greeningService',
  'i18nFilter',
  'CfnDialogService',
  'storage',
  'EVENT_CHART_RESIZE',
  function (
    $scope,
    $rootScope,
    $http,
    $filter,
    $timeout,
    $q,
    $location,
    $locale,
    cropSequencePlanningService,
    greeningService,
    i18nFilter,
    CfnDialogService,
    storage,
    EVENT_CHART_RESIZE,
  ) {
    'use strict';

    $scope.popup = {
      show: false,
      headline: i18nFilter('fe.planning.seedPlanning.notice'),
      content: i18nFilter('fe.planning.cropsequenceplanning.infopopup'),
    };

    $scope.infoMessage = {
      isVisible: false,
      type: 'info',
      closable: true,
      message: i18nFilter(
        'fe.planning.cropsequenceplanning.messages.info.masterdata'
      ),
    };

    var now,
      year = new Date().getFullYear(),
      sysCultures,
      planFruits,
      sortedPlanFruits,
      maxFruitsAllowed = 25,
      gridHelper = {
        planFruitColumns: [], // These are the columns where the User can plan the area of a certain fruit. (on the right)
      },
      planDataTimeout,
      gridReady = $q.defer(),
      opt = {
        indexOfFirstPlanCol: 6,
      },
      rowWatchers = [],
      serverModelWatchers = [],
      nonRemovableCropColumns = [],
      init = function () {
        var sysCulturesPromise;
        var farmsPromise;
        var fieldGroupsPromise;

        $scope.areThereAnyFruitCols = false;
        $scope.allowedYears = [];
        $scope.filterExpression = {};
        $scope.listview = {};

        now = new Date();
        storage.bind($scope, 'selectedYear', {
          defaultValue: null,
          storeName: 'cropSequencePlanningYear',
        });

        cropSequencePlanningService.getAllowedYears().then(function (response) {
          let minYear = year - 2;
          let maxYear = year + 5;
          if (response.data && response.data.length > 0) {
            minYear = Math.min(response.data[0], minYear);
            maxYear = Math.max(
              response.data[response.data.length - 1],
              maxYear
            );
          }
          for (let i = minYear; i <= maxYear; i++) {
            $scope.allowedYears.push(i);
          }

          $scope.allowedYears = _.sortBy($scope.allowedYears, (val) => {
            return val;
          }).reverse();
        });

        sysCulturesPromise = cropSequencePlanningService.getSysCultures(
          function (response) {
            sysCultures = response;

            $scope.sysCulturesById = {};

            _.each(sysCultures, function (item) {
              $scope.sysCulturesById[item.id] = item;
            });
          }
        );

        farmsPromise = cropSequencePlanningService.getFarms(function (
          response
        ) {
          $scope.farms = response;
        });

        fieldGroupsPromise = cropSequencePlanningService.getFieldGroups(
          function (response) {
            $scope.fieldGroups = response;
          }
        );

        $q.all([
          sysCulturesPromise,
          farmsPromise,
          fieldGroupsPromise,
          gridReady.promise,
        ]).then(
          function () {
            // Load last seen planning
            if ($scope.selectedYear) {
              loadFieldPlan($scope.selectedYear);
            }
          },
          function () {
            console.log('error initialising');
          }
        );
      },
      planDataUpdateDebounced = function () {
        if (planDataTimeout) {
          $timeout.cancel(planDataTimeout);
        }

        planDataTimeout = $timeout(updateChart, 150);
      },
      calculateFieldSums = function (field) {
        var calculatedVals = sumUpPlannedAreaPerField(field);

        field.presMdl.sumPlannedArea = calculatedVals.sumPlannedArea;
        field.presMdl.deltaPlannedArea = calculatedVals.deltaPlannedArea;
      },
      // Removes all watchers on view and data model to prevent duplicates
      removeListeners = function () {
        rowWatchers.forEach(function (w) {
          w();
        });

        serverModelWatchers.forEach(function (w) {
          w();
        });
      },
      addListeners = function () {
        // Fill cell with maximum available area on click
        $scope.onFocusPlanField = function (item, fruitType, colIndx) {
          autoMatchArea(item, fruitType, colIndx);
        };

        // synchronize dataModel (fieldPlan) after user has inserted something
        _.each($scope.filteredFieldPlan, function (item, i) {
          // Initially calculate values not received from server
          calculateFieldSums(item);

          rowWatchers.push(
            $scope.$watch(
              "filteredFieldPlan['" + i + "'].presMdl",
              function (newVal, oldVal) {
                var plannedFruits, fieldReference;

                // Skip init
                if (newVal === oldVal) {
                  return;
                }

                plannedFruits = mapPlannedFruitsToDataArray(
                  newVal.plannedFruits
                );

                fieldReference = newVal.getDataItem();
                // Update planned cultures from view model to data model
                // The object updated is both in unfiltered and filtered array

                fieldReference.dataMdl.plannedFruits = plannedFruits;

                calculateFieldSums(fieldReference);

                planDataUpdateDebounced();
              },
              true
            )
          );
        });

        _.each($scope.filteredFieldPlan, function (item, i) {
          serverModelWatchers.push(
            $scope.$watch(
              "filteredFieldPlan['" + i + "'].dataMdl",
              function (newVal, oldVal) {
                // Skip init
                if (newVal === oldVal) {
                  return;
                }

                cropSequencePlanningService.save(
                  $scope.selectedYear,
                  $scope.fieldPlan
                );
              },
              true
            )
          );
        });
      },
      collectplanFruitGridColumn = function () {
        gridHelper.planFruitColumns = [];

        // insert all other columns
        for (
          var i = opt.indexOfFirstPlanCol;
          i < $scope.gridScope.columns.length - 1;
          i++
        ) {
          gridHelper.planFruitColumns.push($scope.gridScope.columns[i]);
        }
      },
      autoMatchArea = function (item, fruitType, colIndx) {
        var curPlannedFruit = item.presMdl.plannedFruits[colIndx],
          isFruitUnplanned,
          plannedFruitType,
          hasSomeSpareArea,
          autoMatchedArea;

        if (!curPlannedFruit.mainFruit) {
          return;
        }

        if (fruitType !== 'mainFruit') {
          return;
        }

        isFruitUnplanned = !curPlannedFruit[fruitType].plannedArea;
        hasSomeSpareArea = item.presMdl.deltaPlannedArea !== 0;

        if (isFruitUnplanned && hasSomeSpareArea) {
          autoMatchedArea =
            item.dataMdl.fieldArea - item.presMdl.sumPlannedArea;

          if (autoMatchedArea > 0) {
            item.presMdl.plannedFruits[colIndx][fruitType].plannedArea =
              autoMatchedArea;
            if (fruitType === 'mainFruit') {
              plannedFruitType = 'MAIN_CROP';
            }

            item.presMdl.plannedFruits[colIndx][fruitType].plannedFruitType =
              plannedFruitType;
            if (item.dataMdl.plannedFruits[colIndx - 1]) {
              item.dataMdl.plannedFruits[colIndx - 1].plannedFruitType =
                plannedFruitType !== undefined ? plannedFruitType : null;
            }
          }
        }
      },
      isAlmostZero = function (num) {
        var isAlmostZero = num < 0.01 && num > -0.01;
        return isAlmostZero ? 0 : num;
      },
      /**
       * Makes sure that fruit abbreviations are not duplicate. If so, adds an index to them.
       */
      createLegendOfFruits = function () {
        var takenAbbr = {},
          currentNumber = 1;
        $scope.sortedPlanFruits.forEach(function (item) {
          // Abbreviation as default title
          item.abbrFruitLegend = item.abbrFruit;

          var existingCulture = takenAbbr[item.abbrFruit];
          if (existingCulture) {
            // Conflict: Abbreviation already in use
            if (existingCulture.abbrFruitLegend === existingCulture.abbrFruit) {
              // Add a legend number to existing culture
              existingCulture.abbrFruitLegend =
                item.abbrFruit + ' (' + currentNumber + ')';
              currentNumber++;
            }
            // Add a legend number to current culture
            item.abbrFruitLegend = item.abbrFruit + ' (' + currentNumber + ')';
            currentNumber++;
          } else {
            // First culture with this abbreviation
            takenAbbr[item.abbrFruit] = item;
            currentNumber = 1;
          }
        });
      },
      sortPlanFruits = function () {
        sortedPlanFruits = _.sortBy(planFruits, function (item) {
          // Sort by a unique string to make sure that order does not change
          return item.abbrFruit + '-' + item.name;
        });

        $scope.sortedPlanFruits = sortedPlanFruits;
      },
      buildGridColumns = function () {
        sortPlanFruits();

        createLegendOfFruits();

        // Hide all plan columns first
        for (
          var c = opt.indexOfFirstPlanCol;
          c < $scope.gridScope.columns.length - 1;
          c++
        ) {
          $scope.gridScope.columns[c].hidden = 'true';
        }
        var maxColumnCountIsReached = false;
        _.each(sortedPlanFruits, function (item, i) {
          var colIndx = i + opt.indexOfFirstPlanCol;
          //we only have 31 columns left for planned fruits (html template) in the table
          maxColumnCountIsReached = colIndx > maxFruitsAllowed + 6;
          if (!maxColumnCountIsReached) {
            $scope.gridScope.columns[colIndx].hidden = 'false';
            $scope.gridScope.columns[colIndx].title = item.abbrFruitLegend;
            $scope.gridScope.columns[colIndx].item = item;
            angular
              .element(document.querySelector('th.col' + colIndx + '> div'))
              .attr('title', item.name);
            if ($scope.gridScope.columns[colIndx].name === 'addFruit') {
              $scope.gridScope.columns[colIndx].title = '';
            }
          } else if ($scope.gridScope.columns[colIndx]) {
            $scope.gridScope.columns[colIndx].hidden = 'true';
          }
        });

        if (maxColumnCountIsReached) {
          CfnDialogService.showMessage(
            i18nFilter(
              'fe.planning.cropsequenceplanning.titleToManyFruits',
              'Maximale Anzahl geplanter und gebuchter Früchte überschritten.'
            ),
            i18nFilter(
              'fe.planning.cropsequenceplanning.msgToManyFruits',
              'Sie haben mehr als {0} geplante und gebuchte Früchte. Es können nicht alle Früchte angezeigt werden.',
              maxFruitsAllowed
            )
          );
        }

        // Apply visible state immediately
        $scope.gridScope.calculateWidths();

        $scope.columnCount = planFruits.length;

        $scope.areThereAnyFruitCols = planFruits.length > 0;

        collectplanFruitGridColumn();
      },
      aggregatePlannedFruitsFromAllFields = function () {
        var aggregatedFruitIds = [];

        planFruits = [];

        // aggregate all culture IDs found in server model
        _.each($scope.fieldPlan, function (item) {
          _.each(item.dataMdl.plannedFruits, function (item2) {
            // Inside crop has no culture
            if (item2.plannedCrop) {
              aggregatedFruitIds[item2.plannedCrop] = true;
            }
            if (item2.plannedFruitType === 'PERMANENT_CROP') {
              item.presMdl.permanentCrop = true;
            }
          });
        });

        // populate array with data from sysCulture Table (different Rest call from fieldmap)
        _.each(_.keys(aggregatedFruitIds), function (id) {
          planFruits.push(_(sysCultures).where({ id: id })[0]);
        });
      },
      /*
       * maps the list of planned cultures in the data model to the columns in the view
       */
      mapPlannedFruitsToColumnArray = function (sortedPlanFruits, field) {
        var plannedFruits = [];

        sortedPlanFruits.forEach(function (fruit) {
          var plannedFruit = _(field.dataMdl.plannedFruits).where({
              plannedCrop: fruit.id,
            }),
            plannedMainFruit = _(plannedFruit).where({
              plannedFruitType: 'MAIN_CROP',
            })[0],
            plannedPermanentFruit = _(plannedFruit).where({
              plannedFruitType: 'PERMANENT_CROP',
            })[0],
            presColumn = {};

          presColumn.mainFruit =
            plannedMainFruit ||
            // Show permanent fruits in column for main crop, sowingType stays PERMANENT_CROP
            plannedPermanentFruit ||
            {};

          // additional fruit parameters are added to the columns model
          // each item has these same fruit-properties so when the user plans certain fruits
          // they are readily available to be put back into dataModel
          var commonFruitInfo = {
            abbrFruit: fruit.abbrFruit,
            id: fruit.id,
            name: fruit.name,
            colour: fruit.colour,
            leavesCereal: fruit.leavesCereal,
          };

          _(presColumn.mainFruit).extend(commonFruitInfo, {
            plannedFruitType: plannedPermanentFruit
              ? 'PERMANENT_CROP'
              : 'MAIN_CROP',
          });

          plannedFruits.push(presColumn);
        });

        return plannedFruits;
      },
      mapPlannedFruitsToDataArray = function (presPlannedFruits) {
        var plannedFruits = [];
        _.each(presPlannedFruits, function (item) {
          if (item.mainFruit && item.mainFruit.plannedArea) {
            plannedFruits.push({
              plannedArea: item.mainFruit.plannedArea,
              plannedCrop: item.mainFruit.id,
              plannedFruitType: item.mainFruit.plannedFruitType,
              readOnly: !!item.mainFruit.readOnly,
            });
          }
        });

        return plannedFruits;
      },
      /**
       * Presentation Model has all the data and pointers that do not belong in the data model
       */
      buildfieldPlanPresentationModel = function () {
        _.each($scope.filteredFieldPlan, function (item) {
          var plannedFruits,
            noCropSequenceDataText = i18nFilter(
              'fe.planning.cropsequenceplanning.nocropsequence',
              '(keine hinterlegt)'
            );

          plannedFruits = mapPlannedFruitsToColumnArray(sortedPlanFruits, item);

          _(item.presMdl).extend({
            referenceFieldID: item.dataMdl.fieldID,
            fieldArea: item.dataMdl.fieldArea,
            plannedFruits: plannedFruits,
            abbrpreviousCrop1st: item.dataMdl.previousCrop1st,
            previousCrop1st: item.dataMdl.previousCrop1st,
            abbrpreviousCrop2nd: item.dataMdl.previousCrop1st,
            previousCrop2nd: item.dataMdl.previousCrop1st,
            abbrpreviousCrop3rd: item.dataMdl.previousCrop1st,
            previousCrop3rd: item.dataMdl.previousCrop1st,
            fieldCropSequence: item.dataMdl.fieldCropSequence
              ? item.dataMdl.fieldCropSequence
              : noCropSequenceDataText,
          });
        });
      },
      // Returns the total area of all (planned) fields
      sumUpAllFieldAreas = function () {
        return _.reduce(
          $scope.filteredFieldsIgnoringFieldGroup,
          function (sum, item) {
            return (
              sum +
              ((item.dataMdl.fieldUsage === 'CROPLAND'
                ? item.dataMdl.fieldArea
                : 0) || 0)
            );
          },
          0
        );
      },
      aggregationToSeries = function (aggregatedAreas) {
        // Base is area of all fields
        var unplannedArea = sumUpAllFieldAreas();
        var series = [];
        _.each(aggregatedAreas, function (culture) {
          series.push({
            name: culture.label,
            fullName: culture.culture.name, // custom property to show the full name hwilöe onMouseOver in the chart
            y: culture.plannedArea,
            sliced: false,
            color: culture.culture.colour,
          });

          unplannedArea -= culture.plannedArea;
        });

        if (unplannedArea > 0) {
          series.push({
            name: i18nFilter('fe.planning.cropsequenceplanning.withoutCulture'),
            fullName: i18nFilter(
              'fe.planning.cropsequenceplanning.withoutCulture'
            ), // custom property to show the full name hwilöe onMouseOver in the chart
            y: unplannedArea,
            sliced: false,
            color: '#ccc',
          });
        }

        return _.sortBy(series, 'y').reverse(); // sort crops by their areas, crops with biggest area first
      },
      addAreaToAggregate = function (aggregate, delta, label) {
        if (delta && delta.plannedArea) {
          // Inside crop also needs an ID
          var id = delta.id || 'null';
          if (!aggregate[id]) {
            aggregate[id] = {
              culture: delta,
              label: label,
              plannedArea: 0,
            };
          }
          aggregate[id].plannedArea += parseFloat(delta.plannedArea);
        }
      },
      updateChart = function () {
        // data not ready yet
        if (!$scope.filteredFieldsIgnoringFieldGroup) {
          return;
        }

        $scope.totalArea = sumUpAllFieldAreas();

        let mainCropCultureAreas = {};

        // Aggregate crop sums by culture
        $scope.filteredFieldsIgnoringFieldGroup.forEach(function (field) {
          // We need to check, if there are planned fruits or not. Otherwise the code will crash.
          if (
            typeof field.presMdl !== 'undefined' &&
            typeof field.presMdl.plannedFruits !== 'undefined'
          ) {
            field.presMdl.plannedFruits.forEach(function (fruit, index) {
              let cultureColumn = sortedPlanFruits[index];
              addAreaToAggregate(
                mainCropCultureAreas,
                fruit.mainFruit,
                cultureColumn.abbrFruitLegend
              ); // main crop
            });
          }
        });

        // calculate and set data for pie charts
        $scope.chartData = {
          mainCrop: aggregationToSeries(mainCropCultureAreas),
        };

        broadcastHightchartsResizing();

        $scope.leavesArea = 0;
        $scope.cerealArea = 0;
        _.each(mainCropCultureAreas, function (culture) {
          if (culture.culture.leavesCereal === 'LEAVES') {
            $scope.leavesArea += culture.plannedArea;
          } else if (culture.culture.leavesCereal === 'CEREAL') {
            $scope.cerealArea += culture.plannedArea;
          }
        });

        // Greening
        var crops = [];
        _.each(mainCropCultureAreas, function (entry) {
          crops.push({
            sowingType: 'MAIN_CROP',
            plannedArea: entry.plannedArea,
          });
        });
        $scope.greeningResults = greeningService.checkGreeningRules({
          totalFieldArea: $scope.totalArea,
          plannedCultures: crops,
        });
      },
      sumUpPlannedAreaPerField = function (field) {
        var sumPlannedArea = 0;
        var plannedFruitsPerField = field.presMdl.plannedFruits;

        if (plannedFruitsPerField) {
          _.each(plannedFruitsPerField, function (fruit) {
            if (fruit.mainFruit && fruit.mainFruit.plannedArea) {
              sumPlannedArea += parseFloat(fruit.mainFruit.plannedArea);
            }
          });
        }

        return {
          sumPlannedArea: sumPlannedArea,
          deltaPlannedArea: isAlmostZero(
            field.dataMdl.fieldArea - sumPlannedArea
          ),
        };
      },
      getByFarmByCropByFields = function () {
        var typeMap = {
          mainFruit: 'MAIN_CROP',
        };

        function addThisUp(key) {
          return function (memoTotal, val) {
            if (key) return memoTotal + deepGet(val, key);
            else return memoTotal + val;
          };
        }

        return _($scope.filteredFieldPlan) // hier ist die Tabelle drin aus der Planung
          .chain()
          .reduce(function (object, currentValue) {
            // build structure for object (byFarm - byCrop - byField)
            _(currentValue.presMdl.plannedFruits).each(function (crop) {
              var cropId, rowId, farmId;

              _.each(['mainFruit'], function (keyPlanningtype) {
                if (!crop[keyPlanningtype].plannedArea) {
                  return;
                }

                cropId = crop[keyPlanningtype].id;
                farmId = currentValue.dataMdl.farmID;
                rowId =
                  currentValue.dataMdl.fieldName.toLowerCase() +
                  currentValue.dataMdl.fieldID +
                  keyPlanningtype;

                object[farmId] = object[farmId] || {};
                object[farmId].crops = object[farmId].crops || {};
                object[farmId].crops[cropId] =
                  object[farmId].crops[cropId] || {};
                object[farmId].crops[cropId].plannedFields =
                  object[farmId].crops[cropId].plannedFields || {};

                object[farmId].crops[cropId].plannedFields[rowId] = {
                  field: currentValue.dataMdl,
                  planned: crop[keyPlanningtype],
                  type: typeMap[keyPlanningtype],
                };

                object[farmId].crops[cropId].crop = crop.mainFruit;
                object[farmId].farmName = currentValue.dataMdl.farmName;
                object[farmId].fieldAreaTotal =
                  $scope.allFarms[farmId].farmableArea;
              });
            });

            return object;
          }, {})
          .map(function (farm) {
            // calculate totals

            _.map(farm.crops, function (crop) {
              crop.plannedAreaTotal = _.reduce(
                crop.plannedFields,
                addThisUp('planned.plannedArea'),
                0
              );

              crop.fieldAreaTotal = _.chain(crop.plannedFields)
                .reduce(function (byFieldMap, field) {
                  byFieldMap[field.field.fieldID] = field.field.fieldArea;
                  return byFieldMap;
                }, {})
                .reduce(addThisUp(), 0)
                .value();

              return crop;
            });

            farm.plannedAreaTotal = _.reduce(
              farm.crops,
              addThisUp('plannedAreaTotal'),
              0
            );

            return farm;
          })
          .map(function (farm) {
            // calculate ratios
            _.map(farm.crops, function (crop) {
              crop.plannedAreaRatio =
                crop.plannedAreaTotal / farm.plannedAreaTotal;

              return crop;
            });

            return farm;
          })
          .map(function (farm) {
            // the planned fields are unordered CFNPOC-39912 --> order by attribute name
            for (var index in farm.crops) {
              var orderedFields = {};

              Object.keys(farm.crops[index].plannedFields)
                .sort()
                .forEach(function (key) {
                  orderedFields[key] = farm.crops[index].plannedFields[key];
                });

              farm.crops[index].plannedFields = orderedFields;
            }

            return farm;
          })
          .value();
      },
      /**
       * Loads a planning for the given year from the backend
       * @param {number} selectedYear - planning year to load
       */
      loadFieldPlan = function (selectedYear) {
        var acceptPlan = function (response, farms, isFieldListChanged) {
          // Prevent an apparent model change to trigger a save after load
          removeListeners();
          $scope.fieldPlan = response.filter((row) => {
            if (row.dataMdl.fieldUsage === 'CROPLAND') {
              return row;
            }
          });
          $scope.allFarms = farms;

          // Make sure graphs are positioned correctly even if invisible before
          $timeout(updateChart);

          nonRemovableCropColumns = [];

          $scope.filterData = $scope.filterData || {};

          $scope.fieldPlan.forEach(function (row) {
            row.dataMdl.plannedFruits.forEach(function (plannedCulture) {
              var hasCropId = !!plannedCulture.plannedCrop,
                isAlreadyNonRemovable =
                  nonRemovableCropColumns[plannedCulture.plannedCrop];

              if (hasCropId && !isAlreadyNonRemovable) {
                nonRemovableCropColumns[plannedCulture.plannedCrop] =
                  !_.isUndefined(plannedCulture.plannedArea) &&
                  plannedCulture.readOnly;
              }
            });
          });

          if (isFieldListChanged) {
            CfnDialogService.showMessage(
              i18nFilter(
                'fe.planning.cropsequenceplanning.fieldListUpdated.title'
              ),
              i18nFilter(
                'fe.planning.cropsequenceplanning.fieldListUpdated.message'
              )
            );

            //there's nothing more we can do. So save this as a signal that the user was already informed.
            //we could store this in a cookie or so to avoid showing it too oft...
            cropSequencePlanningService.save(
              $scope.selectedYear,
              $scope.fieldPlan
            );
          }

          aggregatePlannedFruitsFromAllFields();

          applyFieldPlan();
        };

        if (selectedYear) {
          // Load plan from service
          cropSequencePlanningService.getPlan(
            {
              selectedYear: selectedYear,
            },
            acceptPlan
          );
        } else {
          // Show empty plan
          acceptPlan([]);
        }
      },
      /**
       * Filters and renders the planning
       */
      applyFieldPlan = function () {
        var serverModel = $scope.fieldPlan;
        if (serverModel) {
          // Workaround since backend does not send this field yet
          serverModel.forEach(function (r) {
            r.dataMdl.fieldGroupIDs = r.dataMdl.fieldGroupIDs || [];
          });

          // Apply filters
          $scope.filteredFieldPlan = filterFields(serverModel, false); // for planning and list view
          $scope.filteredFieldsIgnoringFieldGroup = filterFields(
            serverModel,
            true
          ); // for diagram view

          buildGridColumns();

          buildfieldPlanPresentationModel();

          $scope.listview.byFarmCropField = getByFarmByCropByFields(); // refresh list view with filtered data

          removeListeners();

          addListeners();

          $scope.isDataInitialized = true;

          updateChart();
        }
      },
      /**
       * Adds a list of cultures to the current plan
       *
       * @param {Array} sysCultureIds - list of UUIDs of SysCultures
       * @return number of cultures that have actually been added
       */
      addCulturesToPlan = function (sysCultureIds) {
        var addCount = 0;

        sysCultureIds.forEach(function (sysCultureId) {
          var alreadyExists = _(planFruits).where({ id: sysCultureId })[0];

          if (!alreadyExists) {
            addCount++;
            planFruits.push(_(sysCultures).where({ id: sysCultureId })[0]);
          }
        });

        // Refresh grid
        buildGridColumns();
        buildfieldPlanPresentationModel();

        return addCount;
      };

    function filterFields(fieldList, ignoreFieldGroup) {
      return fieldList.filter(function (field) {
        // Filter fields that belong to selected farm
        var farmFilter =
          !$scope.filterExpression.farmID ||
          $scope.filterExpression.farmID === field.dataMdl.farmID;

        // Filter fields that are in selected field group
        var fieldGroupFilter =
          ignoreFieldGroup ||
          !$scope.filterExpression.fieldGroupID ||
          field.dataMdl.fieldGroupIDs.some(function (fieldGroupID) {
            return fieldGroupID === $scope.filterExpression.fieldGroupID;
          });

        return farmFilter && fieldGroupFilter;
      });
    }

    $scope.cropSequenceAddCulturePopup = cropSequenceAddCulturePopup;

    /**
     * Scope vars.
     * Please don't abolish this notation because this is the only way to keep new code clean.
     * Otherwise then there is no chance to understand what's hapenning in this controller.
     * There are just to many other variables waiting for refactoring.
     */
    _.extend($scope, {
      viewmode: null, // no view mode set until active tab view is resolved
      mainTabSwitch: [
        // Tab label data für main tab switch
        {
          label: 'fe.planning.breadcrumb',
          icon: 'dots',
          onSelect: function () {
            $scope.gridScope.gridController.refresh();
            broadcastHightchartsResizing();
            $scope.viewmode = 'PLANNING';
          },
          selected: true,
        },
        {
          label: 'fe.common.overview',
          icon: 'bars',
          onSelect: function () {
            $scope.listview.byFarmCropField = getByFarmByCropByFields();
            broadcastHightchartsResizing();
            $scope.viewmode = 'LIST';
          },
        },
        {
          label: 'fe.planning.cropplanning.statistics.ratioAndGreening',
          icon: 'piechart',
          onSelect: function () {
            broadcastHightchartsResizing();
            $scope.viewmode = 'DIAGRAM';
          },
        },
      ],
      // Flag for grid initialization.
      // This flag is needed because tab switch relies on initialized grid data.
      // We can only display main tab switch after the grid has been initialized, otherwise we run into NPE.
      isGridInitialized: false,

      // Pie chart data. Will be filled wihtin "updateChart" function
      chartData: {
        mainCrop: null,
      },

      // filtered fields ignoring field groupd ID filter (needed in the greening tab)
      filteredFieldsIgnoringFieldGroup: null,
    });

    /**
     * Scope methods.
     * Please don't abolish this notation because this is the only way to keep new code clean.
     * Otherwise then there is no chance to understand what's hapenning in this controller.
     * There are just to many other functions waiting for refactoring.
     */
    _.extend($scope, {});

    // Private methods BEGIN

    function broadcastHightchartsResizing() {
      $scope.$broadcast(EVENT_CHART_RESIZE);
    }

    // Private methods END

    $scope.loadFieldPlan = loadFieldPlan;

    // Combo box for selected harvest year changed
    $scope.$watch('selectedYear', function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      angular
        .element(document.querySelector('th.col2 > div > span.title'))
        .text(i18nFilter('fe.planning.cropsequenceplanning.previousCrop'));
      angular
        .element(document.querySelector('th.col2 > div > span.second-title'))
        .text(newValue - 3);
      angular
        .element(document.querySelector('th.col3 > div > span.title'))
        .text(i18nFilter('fe.planning.cropsequenceplanning.previousCrop'));
      angular
        .element(document.querySelector('th.col3 > div > span.second-title'))
        .text(newValue - 2);
      angular
        .element(document.querySelector('th.col4 > div > span.title'))
        .text(i18nFilter('fe.planning.cropsequenceplanning.previousCrop'));
      angular
        .element(document.querySelector('th.col4 > div > span.second-title'))
        .text(newValue - 1);
      loadFieldPlan(newValue);
    });

    // A view filter outside the grid changed
    $scope.$watch(
      'filterExpression',
      function (newValue, oldValue) {
        if (newValue === oldValue) {
          return;
        }

        applyFieldPlan();
      },
      true
    );

    $scope.gridInit = function (grid, scope) {
      $scope.gridScope = scope;
      gridReady.resolve();
      $scope.isGridInitialized = true;
    };

    $scope.getCurrentAddFruitBtnPosition = function () {
      if ($scope.gridScope && $scope.gridScope.viewData) {
        //position button at a position in the middle of the column. if there are less lineitems the position will be higher
        return {
          top:
            Math.max(0, ($scope.gridScope.viewData.length * 26) / 2 - 13) +
            'px',
        };
      }
    };

    $scope.onCellClick = function (columnNameId, fieldData) {
      var isPrefruit =
        _.indexOf(
          ['previousCrop1st', 'previousCrop2nd', 'previousCrop3rd'],
          columnNameId
        ) !== -1;

      if (isPrefruit) {
        $scope.temporalilyStoredCell = {
          field: fieldData,
          columnNameId: columnNameId,
        };
      }
    };

    $scope.onTabChange = function () {
      // Reset charts because the dimensions are not initially correct
      updateChart();
    };

    $scope.onPopoverResult = function (result) {
      addCulturesToPlan([result[0].id]);
    };

    /**
     * Add all cultures uses in previous year to the planning
     */
    $scope.addPreviousCultures = function () {
      cropSequencePlanningService
        .getCulturesOfYear($scope.selectedYear - 1)
        .then(
          function (response) {
            var sysCultureIds = response.data;
            var culturesAdded;
            if (sysCultureIds.length > 0) {
              culturesAdded = addCulturesToPlan(sysCultureIds);
            } else {
              culturesAdded = 0;
            }
            if (culturesAdded > 0) {
              // Message: Added cultures
              CfnDialogService.showMessage(
                i18nFilter(
                  'fe.planning.cropsequenceplanning.addPreviousCultures.title',
                  'Übernahme der Früchte'
                ),
                i18nFilter(
                  'fe.planning.cropsequenceplanning.addPreviousCultures.some',
                  'Es wurden {0} Früchte übernommen.',
                  culturesAdded
                )
              );
            } else {
              // Message: No cultures added
              CfnDialogService.showMessage(
                i18nFilter(
                  'fe.planning.cropsequenceplanning.addPreviousCultures.title'
                ),
                i18nFilter(
                  'fe.planning.cropsequenceplanning.addPreviousCultures.none',
                  'Alle Früchte sind bereits hinzugefügt.'
                )
              );
            }
          },
          function () {
            console.error('Error fetching cultures');
            CfnDialogService.showMessage(
              i18nFilter(
                'fe.planning.cropsequenceplanning.addPreviousCultures.title',
                'Übernahme der Früchte'
              ),
              i18nFilter(
                'fe.planning.cropsequenceplanning.addPreviousCultures.some',
                'Es wurden {0} Früchte übernommen.',
                0
              )
            );
          }
        );
    };

    // Filter for innerHTML grid columns of previous crops
    $scope.abbrFruitFilter = function (filterText, modelRow, columnName) {
      var abbrFruit = '',
        culture;
      // Fetch abbreviation of culture to filter there
      if (modelRow.dataMdl[columnName]) {
        culture = $scope.sysCulturesById[modelRow.dataMdl[columnName]];
        if (culture) {
          abbrFruit = culture.abbrFruit;
        } else {
          // Should never happen: Column contains something which is not a sysCultureId.
          // Don't filter in this case
          return true;
        }
      }
      return abbrFruit.toLowerCase().indexOf(filterText.toLowerCase()) > -1;
    };

    $scope.goTo = function (path) {
      $location.path(path);
    };

    $scope.removeCultureFromPlan = function (col) {
      if (!col.item) return; // if this is the wrong column

      if (nonRemovableCropColumns[col.item.id] === true) {
        CfnDialogService.showMessage(
          i18nFilter(
            'fe.common.msgCouldNotDelete.title',
            'Kann nicht entfernt werden.'
          ),
          i18nFilter(
            'fe.planning.cropsequenceplanning.msgCouldNotDelete',
            'Diese Frucht kann nicht entfernt werden, da sie bereits in Buchungen verwendet wird.'
          )
        );
      } else {
        CfnDialogService.showYesNoDialog(
          i18nFilter('fe.common.delete', 'Löschen'),
          i18nFilter('fe.common.areYouSure', 'Sind Sie sicher?'),
          function () {
            doRemoveCultureFromPlan(col.item.id);
          }
        );
      }
    };

    $scope.printThis = function () {
      window.print();
    };

    $scope.exportCsvThis = function () {
      const locale = $locale.localeID.replace('_','-');
      const numberFormatter = new Intl.NumberFormat(locale, {minimumFractionDigits: 4});
      const mappedPlan = $scope.gridScope.filterdData.map(
        ({ dataMdl, presMdl }) => {
          const plan = {
            fieldFarmName: dataMdl.farmName,
            fieldNumber: dataMdl.fieldNumber,
            fieldName: dataMdl.fieldName,
            fieldGroup: dataMdl.fieldGroupIDs[0]
              ? $scope.fieldGroups.find(
                  (fg) => fg.id === dataMdl.fieldGroupIDs[0]
                ).name
              : '',
            fieldPreviousCrop3rd: dataMdl.previousCrop3rd
              ? $scope.sysCulturesById[`${dataMdl.previousCrop3rd}`].name
              : '',
            fieldPreviousCrop2nd: dataMdl.previousCrop2nd
              ? $scope.sysCulturesById[`${dataMdl.previousCrop2nd}`].name
              : '',
            fieldPreviousCrop1st: dataMdl.previousCrop1st
              ? $scope.sysCulturesById[`${dataMdl.previousCrop1st}`].name
              : '',
            fieldArea: numberFormatter.format(dataMdl.fieldArea)
          };
          $scope.sortedPlanFruits.forEach((f, i) => plan[`fieldPlanFruit-${i + 1}`] =  presMdl.plannedFruits[i].mainFruit.plannedArea != null ? 
          numberFormatter.format(presMdl.plannedFruits[i].mainFruit.plannedArea) : '')
          return plan;
        }
      );

      stringify(
        mappedPlan,
        {
          bom: true,
          header: true,
          columns: [
            {
              key: 'fieldFarmName',
              header: i18nFilter('be.reporting.export.csv.farm', 'Betrieb'),
            },
            {
              key: 'fieldNumber',
              header: i18nFilter('fe.common.fieldNumber.short', 'Nr.'),
            },
            {
              key: 'fieldName',
              header: i18nFilter('fe.common.fieldName', 'Schlagname'),
            },
            {
              key: 'fieldGroup',
              header: i18nFilter('fe.common.fieldGroup', 'Schlaggruppe'),
            },
            {
              key: 'fieldPreviousCrop3rd',
              header: `${$scope.selectedYear - 3}`,
            },
            {
              key: 'fieldPreviousCrop2nd',
              header: `${$scope.selectedYear - 2}`,
            },
            {
              key: 'fieldPreviousCrop1st',
              header: `${$scope.selectedYear - 1}`,
            },
            {
              key: 'fieldArea',
              header: i18nFilter(
                'fe.planning.cropplanning.fieldArea',
                'Bew. Fläche'
              ),
              
            },
            ...getPlanFruitNameColumnHeaders(),
          ],
        },
        (error, data) => {
          const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });
          saveAs(blob, `${i18nFilter('fe.planning.cropsequenceplanning', 'Fruchtfolgeplanung')}_${$scope.selectedYear}.csv`);
        }
      );
    };

    function getPlanFruitNameColumnHeaders() {
      return $scope.sortedPlanFruits.map((f, i) => ({
        key: `fieldPlanFruit-${i + 1}`,
        header: f.name,
      }));
    }

    function doRemoveCultureFromPlan(id) {
      planFruits = planFruits.filter(function (el) {
        return el.id !== id;
      });

      // Refresh grid
      buildGridColumns();
      buildfieldPlanPresentationModel();

      cropSequencePlanningService.save($scope.selectedYear, $scope.fieldPlan);
    }

    init();
  },
]);
